import { createAction } from 'typesafe-actions';

export const CONNECT_URL = 'site/CONNECT_URL';
export const connectUrl = createAction(CONNECT_URL)<string>();
